









import { Component, Vue, Prop } from 'vue-property-decorator';
import { BorderType } from '@/models';
import SBProBorder from '@structural/border.vue';

@Component({
    components: {
        'sbpro-border': SBProBorder,
    },
})
export default class SBProPageHeader extends Vue {
    @Prop() private headerClasses!: string;
    @Prop() private borderType!: BorderType;
    @Prop({ default: 'text-white' }) private borderClasses!: string;
    @Prop() private backgroundImage!: string;
}
